
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import AppFooter from "@/components/layout/AppFooter.vue";
import { onScroll } from "@/functions/global.function";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import NewsItem1 from "@/components/items/news/NewsItem1.vue";
import NewsItem2 from "@/components/items/news/NewsItem2.vue";
import NewsItem3 from "@/components/items/news/NewsItem3.vue";

@Component({
  components: {
    NewsItem3,
    NewsItem2,
    NewsItem1,
    AppNavbarSecondary,
    AppFooter,
  },
  filters,
})
export default class News extends Vue {
  @Action("getSchoolNews", { namespace: "school" })
  private getSchoolNews: any;

  private news: Array<any> = [];
  private page = 1;
  private isLastPage = false;
  private isLoading = false;

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private getData(isReload: boolean = false) {
    if (isReload) {
      this.news = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoading && !this.isLastPage) {
      this.getSchoolNews({
        params: {
          page: this.page,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.news = [...this.news, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
      });
    }
  }

  private created() {
    this.getData();
  }

  private mounted() {
    onScroll("#app", this.getData);
  }
}
